/**
 * `core/barba/utils/barbaGetTargetScrollPosition.js`
 *  - 指定されたハッシュ要素のスクロール位置を取得する
 *
 *    @param {Object} data - Barba.js の遷移データ
 *    @param {boolean} considerHeader - ヘッダーの高さを考慮するか（デフォルト: true）
 *    @returns {number} スクロール位置（ピクセル単位）
 *
 * 使用方法:
 * - import {barbaGetTargetScrollPosition} from "./core/barba/utils/barbaGetTargetScrollPosition.js";
 */


import {getContainer, mediaQuery} from "../../../utils/index.js";
import {barbaScrollManager} from "./barbaScrollManager.js";
import {getHeaderOffset} from "../../../utils/smoothScroll.js";


export function barbaGetTargetScrollPosition(data, considerHeader = true) {
  console.log("🔄 Get Scroll Position...");

  // スクロール位置を計算
  let position = {x: 0, y: 0};

  // ヘッダーの高さ分オフセットを取得
  const offset = getHeaderOffset(mediaQuery());

  // プロセス別のスクロール位置取得
  switch (data?.trigger) {
    // ブラウザバック（戻る）動作の場合
    case 'back': {
      position = barbaScrollManager.get('back');
      break;
    }

    // ブラウザフォワード（進む）動作の場合
    case 'forward': {
      position = barbaScrollManager.get('forward');
      break;
    }

    // 通常のbarba遷移
    default: {
      // ハッシュ位置の取得
      let hash = data?.next?.url?.hash || data?.trigger?.hash || data?.trigger?.dataset?.scrollHash || window.location.hash;
      if (hash) {
        // IDセレクタの#が抜けている場合補完する
        if (!hash.startsWith("#")) {
          hash = `#${hash}`;
        }
        const target = getContainer(data).querySelector(hash);
        if (target) {
          const rect = target.getBoundingClientRect();
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          position = {
            x: 0,
            y: rect.top + scrollY - offset, // 要素の位置を取得し、ヘッダー分の高さを差し引く
          };
        }
      }
      barbaScrollManager.resetForward();
      break;
    }
  }

  return position;
}